import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { Table } from '../Table/Table.js';
import { Tbody } from '../Table/Tbody.js';
import { Td } from '../Table/Td.js';
import { Th } from '../Table/Th.js';
import { Thead } from '../Table/Thead.js';
import { Tr } from '../Table/Tr.js';
import { useTable } from '../Table/hooks/useTable.js';

var StandardTable = forwardRef(function StandardTable(_a, ref) {
    var columns = _a.columns, data = _a.data, rowProps = _a.rowProps, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? "white" : _b, _c = _a.stickyHeader, stickyHeader = _c === void 0 ? true : _c, props = __rest(_a, ["columns", "data", "rowProps", "backgroundColor", "stickyHeader"]);
    var getTableProps = useTable().getTableProps;
    return (jsxs(Table, __assign({ ref: ref, sx: __assign({}, (backgroundColor && { backgroundColor: backgroundColor })) }, props, getTableProps(columns), { children: [jsx(Thead, __assign({ sticky: stickyHeader, backgroundColor: backgroundColor }, { children: jsx(Tr, { children: columns.map(function (_a, i) {
                        var Header = _a.Header, id = _a.id, headerProps = _a.headerProps;
                        return (jsx(Th, __assign({}, (typeof headerProps === "function"
                            ? headerProps({ id: id })
                            : headerProps), { children: Header && Header({ id: id }) }), id ? id : i));
                    }) }) })), jsx(Tbody, { children: data.map(function (rowData, i) { return (jsx(Tr, __assign({}, (typeof rowProps === "function"
                    ? rowProps(rowData)
                    : rowProps), { children: columns.map(function (_a, j) {
                        var id = _a.id, Cell = _a.Cell, cellProps = _a.cellProps;
                        return (jsx(Td, __assign({}, (typeof cellProps === "function"
                            ? cellProps({ columnId: id, rowData: rowData })
                            : cellProps), { children: Cell && Cell({ columnId: id, rowData: rowData }) }), id ? id : j));
                    }) }), i)); }) })] })));
});

export { StandardTable };
//# sourceMappingURL=StandardTable.js.map
